'use client';
import React, { useEffect, useState } from 'react';
import FAQAccordion from '@/components/FAQAccordion';
import { createClient } from '@/lib/supabase/client';
import { SITE_NAME } from '@/lib/site-config';

const DEFAULT_FAQS = [
  { q: 'How do I get paid?', a: 'Payments are made via UPI directly to your linked UPI ID. Once your review is approved, payment is processed within 7 working days. No minimum withdrawal threshold.' },
  { q: 'Do I need to buy the product myself?', a: 'In most campaigns, the brand provides the product for free or reimburses the cost. Some campaigns offer a reward without free product. Check each campaign details before applying.' },
  { q: 'Can I review from any city in India?', a: 'Yes! We have campaigns for reviewers across all Indian cities. Some campaigns may be city-specific — Mumbai, Delhi, Bangalore, Hyderabad, Pune, Chennai, Kolkata, and Ahmedabad have the most campaigns.' },
  { q: 'How does the AI quality check work?', a: 'After you submit your review, AI analyzes it for authenticity, detail, and honesty. Reviews scoring 70%+ are approved. Below 70% means you\'ll be asked to improve it.' },
  { q: 'Is there a minimum review length?', a: 'Yes, most campaigns require a minimum of 150 words covering your actual experience with the product. You must include at least 2 product photos.' },
  { q: 'What happens if my review is rejected?', a: 'You\'ll receive specific feedback on why it was rejected and get one chance to revise and resubmit. If the revision is also rejected, no payment is made for that review.' },
  { q: 'Can I refer friends and earn?', a: 'Yes! Our referral program gives you ₹50 for every friend who joins and completes their first approved review. There is no cap on referral earnings.' },
  { q: 'Is there a mobile app?', a: `Yes. Download the ${SITE_NAME} app from Google Play or the App Store. All campaign applications, review submissions, and UPI payouts are managed through the app.` },
];

export default function ReviewersFAQ() {
  const [faqs, setFaqs] = useState(DEFAULT_FAQS);

  useEffect(() => {
    const supabase = createClient();
    supabase?.from('platform_settings')?.select('value')?.eq('key', 'reviewers_faq')?.maybeSingle()?.then(({ data }) => {
        if (data?.value) {
          try { setFaqs(JSON.parse(data?.value)); } catch {}
        }
      });
  }, []);

  return (
    <section className="section-py bg-surface-variant">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary bg-primary-container px-3 py-1 rounded-full mb-3">
            FAQ
          </span>
          <h2 className="font-heading font-bold text-foreground" style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)' }}>
            Reviewer Questions Answered
          </h2>
        </div>
        <FAQAccordion items={faqs} />
      </div>
    </section>
  );
}